$( document ).ready( function() {

	// $( '.tabs__triggers-item' ).click( function( e ) {
	// 	e.preventDefault();
	// 	$( '.tabs__triggers-item' ).removeClass( 'active' );
	// 	$( '.tabs__content-item' ).removeClass( 'active' );
	// 	$( this ).addClass( 'active' );
	// 	$( $( this ).attr( 'href' ) ).addClass( 'active' );
	// });

	var mas = {
		itemSelector: '.grid-item',
		columnWidth: '.grid-sizer',
		gutter: '.gutter-sizer',
		percentPosition: true
	};
	var $grid = $( '.grid' ).masonry( mas );
	$grid.imagesLoaded( function() {
		$grid.masonry({
			itemSelector: '.grid-item',
			columnWidth: '.grid-sizer',
			gutter: '.gutter-sizer',
			percentPosition: true
		});
	});

	// $( 'body' ).on( 'click', '.tabs__content-button', function( e ) {
	// 	e.preventDefault();
	// 	$grid.masonry( 'reloadItems' );
	// 	$grid.masonry({
	// 		itemSelector: '.grid-item',
	// 		columnWidth: '.grid-sizer',
	// 		gutter: '.gutter-sizer',
	// 		percentPosition: true
	// 	});
	//
	// });
	let footerTopButton = $( '#js-footer-top__button' );
	footerTopButton.on( 'click', function( e ) {
		e.preventDefault();
		$( 'html, body' ).animate({ scrollTop: 0 }, 'slow' );
	});
	$( '.open-popup-link' ).magnificPopup({
		removalDelay: 500, //delay removal by X to allow out-animation
		callbacks: {
			beforeOpen: function() {
				this.st.mainClass = this.st.el.attr( 'data-effect' );
			}
		},
		midClick: true,
		preloader: false
	});
	$( window ).resize( function() {
		if ( $( window ).width() > 767 ) {
			$( '.footer__main-menu-block' ).removeClass( 'active' );
			shownForMain = !shownForMain;
			$( '.footer__map-menu-block' ).removeClass( 'active' );
			shownForMap = !shownForMap;
			$( '.wrapper' ).removeClass( ' overflow__wrapper' );
		}
	});
	$( '#query-popup__close' ).on( 'click', function() {
		$.magnificPopup.close();
	});

	let shownForMain = false;
	$( '#footer-menu-button' ).on( 'click', function( e ) {
		e.preventDefault();
		if ( shownForMap ) {
			$( '.footer__map-menu-block' ).removeClass( 'active' );
			shownForMap = !shownForMap;
		}
		if ( shownForMain ) {
			$( '.footer__main-menu-block' ).removeClass( 'active' );
			setTimeout( () => {
				$( '.wrapper' ).removeClass( ' overflow__wrapper' );
			}, 550 );
			shownForMain = !shownForMain;
		} else {
			$( '.footer__main-menu-block' ).addClass( 'active' );
			$( '.wrapper' ).addClass( ' overflow__wrapper' );
			shownForMain = !shownForMain;
		}
	});

	let shownForMap = false;
	$( '.js-open-map-menu' ).on( 'click', function( e ) {
		e.preventDefault();
		if ( shownForMain ) {
			$( '.footer__main-menu-block' ).removeClass( 'active' );
			shownForMain = !shownForMain;
		}
		if ( shownForMap ) {
			$( '.footer__map-menu-block' ).removeClass( 'active' );
			setTimeout( () => {
				$( '.wrapper' ).removeClass( ' overflow__wrapper' );
			}, 550 );
			shownForMap = !shownForMap;
		} else {
			$( '.footer__map-menu-block' ).addClass( 'active' );
			$( '.wrapper' ).addClass( ' overflow__wrapper' );
			shownForMap = !shownForMap;
		}
	});

	$( '.js-search-popup' ).click( function( e ) {
		e.preventDefault();
		$( '.search' ).addClass( 'active' );
	});

	$( '.js-modal-search-close' ).click( function( e ) {
		e.preventDefault();
		$( '.search' ).removeClass( 'active' );
	});
	// $( '.menu-item-has-children' ).children().first().click( function( e ) {
	// 	e.preventDefault();
	// 	$( this ).toggleClass( 'active' ).next().slideToggle( 300 );
	// });
});
